import a31 from "../images/a3/2025_10_04_19_14_IMG_6983.JPG"
import a32 from "../images/a3/2025_10_04_19_15_IMG_6985.JPG"
import a33 from "../images/a3/2025_10_04_19_15_IMG_6987.JPG"
import a34 from "../images/a3/2025_10_04_19_15_IMG_6988.JPG"
import a35 from "../images/a3/2025_10_04_19_15_IMG_6990.JPG"
import a36 from "../images/a3/2025_10_04_19_16_IMG_6991.JPG"
import a37 from "../images/a3/2025_10_04_19_16_IMG_6992.JPG"

import golf1 from "../images/golf8/2025_07_21_19_05_IMG_5278.JPG"
import golf2 from "../images/golf8/2025_07_21_19_04_IMG_5279.JPG"
import golf3 from "../images/golf8/2025_07_21_19_02_IMG_5258.JPG"
import golf4 from "../images/golf8/2025_07_21_19_02_IMG_5257.JPG"
import golf5 from "../images/golf8/2025_07_21_19_00_IMG_5255.JPG"
import golf6 from "../images/golf8/2025_07_21_18_58_IMG_5253.JPG"
import golf7 from "../images/golf8/2025_07_21_18_54_IMG_5249.JPG"
import golf8 from "../images/golf8/2025_07_21_18_54_IMG_5247.JPG"

import porche1 from "../images/porche/2026_01_16_15_55_IMG_8350.JPG"
import porche2 from "../images/porche/2026_01_16_15_56_IMG_8354.JPG"
import porche3 from "../images/porche/2026_01_16_15_56_IMG_8353.JPG"
import porche4 from "../images/porche/2026_01_16_15_56_IMG_8352(1).JPG"
import porche5 from "../images/porche/2026_01_16_15_55_IMG_8350.JPG"

import tucson1 from "../images/tucsonN/2025_05_22_20_02_IMG_4538.JPG"
import tucson2 from "../images/tucsonN/2025_05_22_20_02_IMG_4539.JPG"
import tucson3 from "../images/tucsonN/2025_05_22_20_02_IMG_4542.JPG"
import tucson4 from "../images/tucsonN/2025_05_22_20_02_IMG_4543.JPG"
import tucson5 from "../images/tucsonN/2025_05_22_20_03_IMG_4540.JPG"
import tucson6 from "../images/tucsonN/2025_05_22_20_03_IMG_4541.JPG"
import tucson7 from "../images/tucsonN/2025_05_22_20_03_IMG_4544.JPG"
import tucson8 from "../images/tucsonN/2025_05_22_20_03_IMG_4545.JPG"

import jeep1 from "../images/jeepsahara/2025_12_20_18_33_IMG_7878.JPG"
import jeep2 from "../images/jeepsahara/2025_12_20_18_34_IMG_7883.JPG"
import jeep3 from "../images/jeepsahara/2025_12_20_18_34_IMG_7884.JPG"
import jeep4 from "../images/jeepsahara/2025_12_20_18_34_IMG_7887.JPG"
import jeep5 from "../images/jeepsahara/2025_12_20_18_35_IMG_7888.JPG"
import jeep6 from "../images/jeepsahara/2025_12_20_18_37_IMG_7891.JPG"

import cla1 from "../images/cla/2026_01_06_21_22_IMG_8094.JPG"
import cla2 from "../images/cla/2026_01_06_21_22_IMG_8095.JPG"
import cla3 from "../images/cla/2026_01_06_21_22_IMG_8096.JPG"
import cla4 from "../images/cla/2026_01_06_21_23_IMG_8097.JPG"
import cla5 from "../images/cla/2026_01_06_21_23_IMG_8098.JPG"
import cla6 from "../images/cla/2026_01_06_21_23_IMG_8099.JPG"









export const vehicles = [
  {
    id: "audi-a6-2021",
    images: [a31, a32,a33,a34,a35,a36,a37],
    name: "Audi A3",
    price: "340 000 MAD",
    year: "2023",
    fuel: "Diesel",
    km: "90 000 km",
    gearbox: "Automatique",
  },
  {
    id: "mercedes-c200-2020",
    images: [golf1, golf2, golf3, golf4, golf5, golf6, golf7, golf8],
    name: "GOLF 8 Rline",
    price: "290 000 MAD",
    year: "2023",
    fuel: "Diesel",
    km: "95 000 km",
    gearbox: "Automatique",
  },
  {
    id: "toyota-corolla-2019",
    images: [porche1, porche2,porche3,porche4,porche5],
    name: "Porsche Macan",
    price: "470 000 MAD",
    year: "2023",
    fuel: "Essence",
    km: "90 000 km",
    gearbox: "Automatique",
  },
  {
    id: "audi-a6-2021-2",
    images: [tucson1,tucson2,tucson3,tucson4,tucson5,tucson6,tucson7,tucson8],
    name: "Tucson luxe +",
    price: "270 000 MAD",
    year: "2023",
    fuel: "Diesel",
    km: "85 000 km",
    gearbox: "Automatique",
  },
  {
    id: "audi-a6-2021-3",
    images: [jeep1,jeep2,jeep3,jeep4,jeep5,jeep6],
    name: "Jeep Sahara",
    price: "260 000 MAD",
    year: "2016",
    fuel: "Diesel",
    km: "103 000 km",
    gearbox: "Automatique",
  },
  {
    id: "audi-a6-2021-4",
    images: [cla1,cla2,cla3,cla4,cla5,cla6],
    name: "MERCEDES CLA 220",
    price: "360 000 MAD",
    year: "2022",
    fuel: "Diesel",
    km: "130 000 km",
    gearbox: "Automatique",
  },
];
